import React, { forwardRef } from 'react';
import useMediaQuery, { MOBILE_WIDTH_QUERY } from '../../../components/hooks/useMediaQuery';
import ShiftSlotDesktop from './ShiftSlotDesktop';
import ShiftSlotMobile from './ShiftSlotMobile';

const ShiftSlot = forwardRef(
	(
		{
			slot,
			shift,
			units,
			user,
			isFixedMarkup,
			updateSlotArrivalStatus,
			onConfirm,
			onPrepareCancel,
			handleEditBonusModalButton,
			handleAddBonusModalButton,
			preventGuaranteeOrBonusUpdates,
			onGuaranteedCheckboxChange,
			onGuaranteeBundleChange,
			setShowUnitAssignmentModal,
			setUnitAssignmentSlot,
			assignCaregiver,
			routeSlotAction,
			shouldShowRouteBadges,
			facilityFloatSlotAction
		},
		ref
	) => {
		// eslint-disable-next-line camelcase
		const getUnitName = (_id) => units.find((u) => u.id === _id)?.unit_name;

		const isMobile = useMediaQuery(MOBILE_WIDTH_QUERY);
		return isMobile ? (
			<ShiftSlotMobile
				slot={slot}
				units={units}
				user={user}
				isFixedMarkup={isFixedMarkup}
				updateSlotArrivalStatus={updateSlotArrivalStatus}
				onConfirm={onConfirm}
				onPrepareCancel={onPrepareCancel}
				handleEditBonusModalButton={handleEditBonusModalButton}
				handleAddBonusModalButton={handleAddBonusModalButton}
				preventGuaranteeOrBonusUpdates={preventGuaranteeOrBonusUpdates}
				onGuaranteedCheckboxChange={onGuaranteedCheckboxChange}
				onGuaranteeBundleChange={onGuaranteeBundleChange}
				setShowUnitAssignmentModal={setShowUnitAssignmentModal}
				setUnitAssignmentSlot={setUnitAssignmentSlot}
				getUnitName={getUnitName}
				onAssign={assignCaregiver}
				ref={ref}
				routeSlotAction={routeSlotAction}
				facilityFloatSlotAction={facilityFloatSlotAction}
				shouldShowRouteBadges={shouldShowRouteBadges}
			/>
		) : (
			<ShiftSlotDesktop
				slot={slot}
				shift={shift}
				units={units}
				user={user}
				isFixedMarkup={isFixedMarkup}
				updateSlotArrivalStatus={updateSlotArrivalStatus}
				onConfirm={onConfirm}
				onPrepareCancel={onPrepareCancel}
				handleEditBonusModalButton={handleEditBonusModalButton}
				handleAddBonusModalButton={handleAddBonusModalButton}
				preventGuaranteeOrBonusUpdates={preventGuaranteeOrBonusUpdates}
				onGuaranteedCheckboxChange={onGuaranteedCheckboxChange}
				onGuaranteeBundleChange={onGuaranteeBundleChange}
				setShowUnitAssignmentModal={setShowUnitAssignmentModal}
				setUnitAssignmentSlot={setUnitAssignmentSlot}
				getUnitName={getUnitName}
				onAssign={assignCaregiver}
				ref={ref}
				routeSlotAction={routeSlotAction}
				facilityFloatSlotAction={facilityFloatSlotAction}
				shouldShowRouteBadges={shouldShowRouteBadges}
			/>
		);
	}
);

export default ShiftSlot;
